const newName = 'XS-Barbershop GmbH';
const CompanyName = newName;

export default CompanyName;

